import { render, staticRenderFns } from "./SuggestedTeamTypes.vue?vue&type=template&id=44d2f0d2&scoped=true&"
import script from "./SuggestedTeamTypes.vue?vue&type=script&lang=js&"
export * from "./SuggestedTeamTypes.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTeamTypes.vue?vue&type=style&index=0&id=44d2f0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2f0d2",
  null
  
)

export default component.exports